import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Checkbox, Container, ExpandableSection, FormField, Input, Multiselect, Select, SelectProps, SpaceBetween, Textarea } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../../components/extras/Favorites';
import SelectCheck from '../../../../../components/selects/selectChecks';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemCheck, ItemnCheckParametersGroup, OptionDefinition } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

interface OptionGroup {
    label: string;
    options: OptionDefinition[];
}


export const EDVCheckMasters = () => {
    const { menu } = useGlobalState();

    const [checks, setChecks] = useState<ItemCheck[]>([]);
    const [checksOptions, setChecksOptions] = useState<OptionDefinition[]>([]);
    const [checkParameter, setCheckParameter] = useState<ItemnCheckParametersGroup[]>([]);
    const [checkParametersOptions, setCheckParametersOptions] = React.useState<SelectProps.Option | null>(null);


    const [selectCheckParameters, setSelectCheckParameters] = useState<OptionGroup[]>([]);
    const [includeInactive, setIncludeInactive] = useState(0);
    const [includeDeleted, setIncludeDeleted] = useState(0);
    const [checkParameters, setCheckParameters] = useState<ItemnCheckParametersGroup[]>([]);
    const [check, setCheck] = useState<ItemCheck | null>(null);
    //const [selectedOptions, setSelectedOptions] = useState<OptionDefinition[]>([]);

    const [selectedCheckParameters, setSelectedCheckParameters] = React.useState<SelectProps.Option[]>([]);
    const [selectedOption, setSelectedOption] = React.useState<SelectProps.Option | null>(null);

    useGlobalState();

    const { navigate } = useRouter();

    const isNotCheckUpdatable = !check || !check.equipmentCheck || check.equipmentCheck === "" || !check.instructorCheck || check.instructorCheck === "" || !check.equipmentCheck || check.equipmentCheck === "" || !check.check || check.check === "" || !check.expiresIn || check.expiresIn <= 0;





    const handleUpdate = async () => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/checks/update',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(check)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.status) {
                if (data.code === 0) {
                    setCheck(null)
                    setSelectedOption(null)
                    handleRefresh()
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
            addNotification(`Error de red y/o comunicaciones: ${error}`, "error", setData);
        } finally {
            setLoading(false);

        }

    };

    const handleGetCheck = async (idCheck: number) => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/checks/get',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idCheck: idCheck
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                if (data.check) {
                    let idCheckParameters: number[] = []
                    const options = data.check.jsonParams.map((param: { checkEval: any; idCheckParameter: any; }) => ({
                        label: param.checkEval,
                        value: String(param.idCheckParameter)
                    }));

                    const options2 = data.check.jsonParams.map((param: { checkEval: any; idCheckParameter: any; }) => {
                        idCheckParameters.push(Number(param.idCheckParameter))
                    });
                    data.check.idCheckParameters = idCheckParameters
                    setCheck(data.check)
                    setSelectedCheckParameters(options)
                    //setCheckParameters(data.check.jsonParam)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };



    useEffect(() => {
        if (selectedCheckParameters && checkParameters && check) {
            check.idCheckParameters = selectedCheckParameters.map(param => Number(param.value));
        }
    }, [selectedCheckParameters]);



    const handleRefresh = async () => {
        //try {

        setLoading(true);
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-routing': '/private/global/checks/list',
                'JWT': getCookie("JWT"),

            },
            body: JSON.stringify({
                checkParameters: true,
                isActiveCheck: -1,
                isDeleteCheck: -1,
                limit: 1000,
                columns: "idCheck, [check], isActiveCheck, isDeleteCheck, equipmentCheck, instructorCheck",
                orderBy: "[check]",
                order: "asc"
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error: ${response.status}`);
        }

        const data = await response.json();

        if (data.code === 0) {
            if (data.checkParameters) {
                //setChecksParameters(data.checksParameters);
                const selectOptions: OptionGroup[] = (data?.checkParameters ?? []).map(
                    (item: ItemnCheckParametersGroup) => ({
                        label: item.type,
                        options: item.data.map((checkParam) => ({
                            label: `${checkParam.checkEval}`,
                            value: String(checkParam.idCheckParameter), // Guarantees string conversion
                        })),
                    })
                );
                setCheckParameters(data.checkParameters);
                if (selectOptions)
                    setSelectCheckParameters(selectOptions)
            }
            if (data.checks) {
                setChecks(data.checks);
            }
        }
        setLoading(false);
        /*
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
            */
    };
    useEffect(() => {
        handleRefresh()
    }, []);



    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Mantenedor de chequeos</Header>
                    <SpaceBetween size="s" direction='horizontal'>
                        <div style={{ width: 250 }}>
                            <SelectCheck
                                single
                                checks={checks}
                                includeInactive={includeInactive === 1}
                                includeDeleted={includeDeleted === 1}
                                onSelect={(selectedCheck) => {
                                    if (selectedCheck) {
                                        handleGetCheck(Number(selectedCheck))
                                    }
                                }}
                            />
                        </div>
                        <Checkbox checked={includeInactive === 1} onChange={(detail) => setIncludeInactive(detail.detail.checked ? 1 : 0)}>Incluir inactivos</Checkbox>
                        <Checkbox checked={includeDeleted === 1} onChange={(detail) => setIncludeDeleted(detail.detail.checked ? 1 : 0)}>Incluir eliminados</Checkbox>
                        <Button variant='primary' onClick={() => {
                            const localCheck: ItemCheck = {
                                idRequest: 0, idCheck: 0, check: "Nuevo chequeo", expiresIn: 30, isActiveCheck: 1, isDeleteCheck: 0, isRepeat: 0, requisitosCondicion: "", curso: "", chequeo: "", habilitacion: "", requisitosFamiliarizacion: "", observaciones: "", idCheckParameters: [], statusRequest: 0,
                                idUser: 0,
                                idInstructor: 0,
                                category: '',
                                displayName: '',
                                instructor: '',
                                dateAssigned: '',
                                dateExpires: '',
                                dateResult: '',
                                dateSubmited: '',
                                resultItem: '',
                                obsPilot: '',
                                result: '',
                                cancelReason: '',
                                jsonResults: [],
                                jsonParams: [],
                                obs: '',
                                icon: '',
                                equipmentCheck: '',
                                instructorCheck: '',
                                label: '',
                                value: ''
                            };
                            setCheck(localCheck);
                            setSelectedOption(null)
                        }}>Nuevo chequeo</Button>

                    </SpaceBetween>
                    {check && (
                        <Container variant="stacked" header={<Header variant='h2'>{check.check} {check.idCheck > 0 ? `[${check.idCheck}]` : null}</Header>} footer={
                            <Box textAlign='right'>
                                <Button variant='primary' disabled={isNotCheckUpdatable} onClick={() => handleUpdate()}>{check.idCheck === 0 ? "Crear" : "Actualizar"}</Button>
                            </Box>
                        }>
                            <SpaceBetween size="s">
                                <ExpandableSection expanded headerText="General" key={"general"}>
                                    <SpaceBetween size="s">

                                        <FormField label={"Nombre de chequeo"}>
                                            <Input value={check.check} onChange={(detail) => setCheck({ ...check, check: detail.detail.value })} />
                                        </FormField>
                                        <SpaceBetween size="s" direction='horizontal'>
                                            <FormField label={"Expiración"} constraintText={"Días hasta expiración automática"}>
                                                <Input type='number' value={check.expiresIn.toString()} onChange={(detail) => setCheck({ ...check, expiresIn: Number(detail.detail.value) })} />
                                            </FormField>
                                            <FormField label={"Categorización"} constraintText={"Agrupamiento"}>
                                                <Select
                                                    selectedOption={
                                                        check.equipmentCheck
                                                            ? { label: getCategoryLabel(check.equipmentCheck), value: check.equipmentCheck }
                                                            : null
                                                    }
                                                    onChange={({ detail }) => {
                                                        setCheck({ ...check, equipmentCheck: detail.selectedOption.value || "" });


                                                    }}
                                                    options={[
                                                        { label: "Planeador", value: "GLIDER" },
                                                        { label: "Remolcador", value: "TOW" },
                                                        { label: "Avión", value: "PLANE" },
                                                        { label: "Helicoptero", value: "HELI" },
                                                        { label: "Curso", value: "COURSE" },
                                                        { label: "Zona", value: "ZONE" },
                                                        { label: "DGAC", value: "DGAC" },
                                                        { label: "FAI", value: "FAI" },
                                                    ]}
                                                />
                                            </FormField>
                                            <FormField label={"Tipo instructor"} constraintText={"Asociación de instrucción"}>
                                                <Select
                                                    selectedOption={
                                                        check.instructorCheck
                                                            ? { label: getCategoryLabel(check.instructorCheck), value: check.instructorCheck }
                                                            : null
                                                    }
                                                    onChange={({ detail }) => {
                                                        setCheck({ ...check, instructorCheck: detail.selectedOption.value || "" });

                                                    }}
                                                    options={[
                                                        { label: "Planeador", value: "GLIDER" },
                                                        { label: "Avión", value: "PLANE" },
                                                        { label: "Helicoptero", value: "HELI" },
                                                        { label: "Simulador", value: "SIM" },
                                                        { label: "Teórico", value: "TEO" },
                                                        { label: "Indiferente", value: "ALL" },
                                                    ]}
                                                />
                                            </FormField>
                                        </SpaceBetween>
                                        <SpaceBetween size="s" direction='horizontal'>
                                            <Checkbox checked={!!check && check.isRepeat === 1} onChange={(detail) => { if (check) setCheck({ ...check, isRepeat: detail.detail.checked ? 1 : 0 }) }}
                                            >Chequeos múltiples</Checkbox>
                                            <Checkbox checked={check.isActiveCheck === 1} onChange={(detail) => setCheck({ ...check, isActiveCheck: detail.detail.checked ? 1 : 0 })}>
                                                Chequeo esta activo
                                            </Checkbox>
                                            <Checkbox checked={check.isDeleteCheck === 1} onChange={(detail) => setCheck({ ...check, isDeleteCheck: detail.detail.checked ? 1 : 0 })}>
                                                Chequeo esta eliminado
                                            </Checkbox>

                                        </SpaceBetween>
                                    </SpaceBetween>
                                </ExpandableSection>
                                <ExpandableSection headerText="Parámetros" key={"param"}>
                                    <FormField label={"Selector de parámetros"} info={selectedCheckParameters.length > 0 ? `${selectedCheckParameters.length} seleccionados` : "Ninguno seleccionado"}>

                                        <Multiselect
                                            selectedOptions={selectedCheckParameters}
                                            onChange={({ detail }) => {
                                                setSelectedCheckParameters([...detail.selectedOptions])
                                            }}
                                            options={selectCheckParameters}
                                            filteringType="auto"
                                            tokenLimit={10}
                                        />
                                    </FormField>

                                </ExpandableSection>
                                <ExpandableSection headerText="Requisitos/Condiciones" key={"cond"}>
                                    <Textarea value={check.requisitosCondicion.replace(/;;;/g, "\n")} onChange={(detail) => setCheck({ ...check, requisitosCondicion: detail.detail.value })} />
                                </ExpandableSection>
                                <ExpandableSection headerText="Curso" key={"curso"}>
                                    <Textarea value={check.curso.replace(/;;;/g, "\n")} onChange={(detail) => setCheck({ ...check, curso: detail.detail.value })} />
                                </ExpandableSection>
                                <ExpandableSection headerText="Chequeo" key={"che"}>
                                    <Textarea value={check.chequeo.replace(/;;;/g, "\n")} onChange={(detail) => setCheck({ ...check, chequeo: detail.detail.value })} />
                                </ExpandableSection>
                                <ExpandableSection headerText="Habilitación" key={"hab"}>
                                    <Textarea value={check.habilitacion.replace(/;;;/g, "\n")} onChange={(detail) => setCheck({ ...check, habilitacion: detail.detail.value })} />
                                </ExpandableSection>
                                <ExpandableSection headerText="Requisitos/Familiarización" key={"req"}>
                                    <Textarea value={check.requisitosFamiliarizacion.replace(/;;;/g, "\n")} onChange={(detail) => setCheck({ ...check, requisitosFamiliarizacion: detail.detail.value })} />
                                </ExpandableSection>
                                <ExpandableSection headerText="Observaciones" key={"obs"}>
                                    <Textarea value={check.observaciones.replace(/;;;/g, "\n")} onChange={(detail) => setCheck({ ...check, observaciones: detail.detail.value })} />
                                </ExpandableSection>
                            </SpaceBetween>
                        </Container>
                    )}
                </SpaceBetween>
            }
        />
    );
};


function getCategoryLabel(value: string): string {
    switch (value) {
        case "GLIDER":
            return "Planeador";
        case "PLANE":
            return "Avión";
        case "HELI":
            return "Helicóptero";
        case "TOW":
            return "Remolcador";
        case "COURSE":
            return "Curso";
        case "ZONE":
            return "Zona";
        case "SIM":
            return "Simulador";
        case "TEO":
            return "Teórico";
        case "ALL":
            return "Indiferente";
        default:
            return value;
    }
}